import React from "react";

interface HeightWatchProps {
    onChange(height: number): void;
    children: React.ReactNode;
}

export const HeightWatch: React.FC<HeightWatchProps> = ({ children, onChange }: HeightWatchProps) => {
    return (
        <div
            ref={(el) => {
                if (el !== null) {
                    onChange(el.offsetHeight);
                }
            }}
        >
            {children}
        </div>
    );
};
